import React from "react";

import loading from '../assets/icons/loading.gif';

function Loading() {
    return (
        <div className="absolute flex items-center justify-center w-full h-full bg-black z-[9999]">
            <img src={loading} alt={loading} className="w-[64px]"/>
        </div>
    );
}

export default Loading;
